import { getTermsValue, resetTerms, setTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { SALE_TYPES_MAP_VALUE_TO_LABEL } from './constants';
import { ESaleType } from '../../../../api-models/common/json_query';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'saleType' as const;

export const saleTypeTagsManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const saleTypes = getTermsValue('sost_type')(jsonQuery);

    if (saleTypes === null || saleTypes.includes(ESaleType.Any)) {
      return null;
    }

    return saleTypes.map(saleType => ({
      label: SALE_TYPES_MAP_VALUE_TO_LABEL[saleType],
      value: createTagValue(ID, saleType.toString()),
    }));
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery, removingTagValue }) => {
    const saleTypes = getTermsValue('sost_type')(jsonQuery);

    if (saleTypes === null) {
      return jsonQuery;
    }

    const newSaleTypes = saleTypes.filter(saleType => String(saleType) !== removingTagValue);

    return newSaleTypes.length ? setTerms('sost_type')(jsonQuery)(newSaleTypes) : resetTerms(['sost_type'])(jsonQuery);
  },
};
